import { AppRouterInstance } from 'next/dist/shared/lib/app-router-context.shared-runtime'

let _router: AppRouterInstance | null = null

export const setRouter = (router: AppRouterInstance) => {
  _router = router
}

export const navigate = (path: string) => {
  if (_router) {
    _router.push(path)
  } else if (typeof window !== 'undefined') {
    window.location.replace(path)
  }
}
